export type CimmplePayDocItem = {
  sourcePath: string;
  routePath: string;
  title: string;
};

export const cimmplePayDocsManifest: CimmplePayDocItem[] = [
  {
    "sourcePath": "api-quick-reference.md",
    "routePath": "api-quick-reference",
    "title": "API Quick Reference"
  },
  {
    "sourcePath": "authentication.md",
    "routePath": "authentication",
    "title": "Authentication"
  },
  {
    "sourcePath": "core-flows.md",
    "routePath": "core-flows",
    "title": "Core Integration Flows"
  },
  {
    "sourcePath": "getting-started.md",
    "routePath": "getting-started",
    "title": "Getting Started"
  },
  {
    "sourcePath": "go-live-checklist.md",
    "routePath": "go-live-checklist",
    "title": "Go-Live Checklist"
  },
  {
    "sourcePath": "README.md",
    "routePath": "",
    "title": "CimmplePay Integration Docs"
  },
  {
    "sourcePath": "reference/audit-logs/create-audit-log.md",
    "routePath": "reference/audit-logs/create-audit-log",
    "title": "Create Audit Log"
  },
  {
    "sourcePath": "reference/audit-logs/get-audit-log.md",
    "routePath": "reference/audit-logs/get-audit-log",
    "title": "Get Audit Log"
  },
  {
    "sourcePath": "reference/audit-logs/list-audit-logs.md",
    "routePath": "reference/audit-logs/list-audit-logs",
    "title": "List Audit Logs"
  },
  {
    "sourcePath": "reference/auth/change-password.md",
    "routePath": "reference/auth/change-password",
    "title": "Change Password"
  },
  {
    "sourcePath": "reference/auth/list-user-companies.md",
    "routePath": "reference/auth/list-user-companies",
    "title": "List User Companies (Auth)"
  },
  {
    "sourcePath": "reference/auth/login.md",
    "routePath": "reference/auth/login",
    "title": "Login"
  },
  {
    "sourcePath": "reference/auth/me.md",
    "routePath": "reference/auth/me",
    "title": "Get Current User"
  },
  {
    "sourcePath": "reference/auth/register.md",
    "routePath": "reference/auth/register",
    "title": "Register User"
  },
  {
    "sourcePath": "reference/auth/reset-admin-password.md",
    "routePath": "reference/auth/reset-admin-password",
    "title": "Reset Admin Password (Development)"
  },
  {
    "sourcePath": "reference/auth/switch-company.md",
    "routePath": "reference/auth/switch-company",
    "title": "Switch Company"
  },
  {
    "sourcePath": "reference/beneficiaries/create-beneficiary.md",
    "routePath": "reference/beneficiaries/create-beneficiary",
    "title": "Create Beneficiary"
  },
  {
    "sourcePath": "reference/beneficiaries/delete-beneficiary.md",
    "routePath": "reference/beneficiaries/delete-beneficiary",
    "title": "Delete Beneficiary"
  },
  {
    "sourcePath": "reference/beneficiaries/get-beneficiary.md",
    "routePath": "reference/beneficiaries/get-beneficiary",
    "title": "Get Beneficiary"
  },
  {
    "sourcePath": "reference/beneficiaries/list-beneficiaries.md",
    "routePath": "reference/beneficiaries/list-beneficiaries",
    "title": "List Beneficiaries For Employee"
  },
  {
    "sourcePath": "reference/beneficiaries/update-beneficiary.md",
    "routePath": "reference/beneficiaries/update-beneficiary",
    "title": "Update Beneficiary"
  },
  {
    "sourcePath": "reference/beneficiaries/validate-beneficiaries.md",
    "routePath": "reference/beneficiaries/validate-beneficiaries",
    "title": "Validate Beneficiary Allocations"
  },
  {
    "sourcePath": "reference/benefits/assign-benefit-to-employee.md",
    "routePath": "reference/benefits/assign-benefit-to-employee",
    "title": "Assign Benefit To Employee"
  },
  {
    "sourcePath": "reference/benefits/create-benefit.md",
    "routePath": "reference/benefits/create-benefit",
    "title": "Create Benefit"
  },
  {
    "sourcePath": "reference/benefits/delete-benefit.md",
    "routePath": "reference/benefits/delete-benefit",
    "title": "Delete Benefit"
  },
  {
    "sourcePath": "reference/benefits/get-benefit.md",
    "routePath": "reference/benefits/get-benefit",
    "title": "Get Benefit"
  },
  {
    "sourcePath": "reference/benefits/list-benefits.md",
    "routePath": "reference/benefits/list-benefits",
    "title": "List Benefits"
  },
  {
    "sourcePath": "reference/benefits/list-employee-benefits.md",
    "routePath": "reference/benefits/list-employee-benefits",
    "title": "List Employee Benefits"
  },
  {
    "sourcePath": "reference/benefits/remove-employee-benefit.md",
    "routePath": "reference/benefits/remove-employee-benefit",
    "title": "Remove Employee Benefit Assignment"
  },
  {
    "sourcePath": "reference/benefits/update-benefit.md",
    "routePath": "reference/benefits/update-benefit",
    "title": "Update Benefit"
  },
  {
    "sourcePath": "reference/companies/create-company.md",
    "routePath": "reference/companies/create-company",
    "title": "Create Company"
  },
  {
    "sourcePath": "reference/companies/delete-company.md",
    "routePath": "reference/companies/delete-company",
    "title": "Delete Company"
  },
  {
    "sourcePath": "reference/companies/get-company.md",
    "routePath": "reference/companies/get-company",
    "title": "Get Company"
  },
  {
    "sourcePath": "reference/companies/list-companies.md",
    "routePath": "reference/companies/list-companies",
    "title": "List Companies"
  },
  {
    "sourcePath": "reference/companies/update-company.md",
    "routePath": "reference/companies/update-company",
    "title": "Update Company"
  },
  {
    "sourcePath": "reference/deductions/assign-deduction-to-employee.md",
    "routePath": "reference/deductions/assign-deduction-to-employee",
    "title": "Assign Deduction To Employee"
  },
  {
    "sourcePath": "reference/deductions/create-deduction.md",
    "routePath": "reference/deductions/create-deduction",
    "title": "Create Deduction"
  },
  {
    "sourcePath": "reference/deductions/delete-deduction.md",
    "routePath": "reference/deductions/delete-deduction",
    "title": "Delete Deduction"
  },
  {
    "sourcePath": "reference/deductions/get-deduction.md",
    "routePath": "reference/deductions/get-deduction",
    "title": "Get Deduction"
  },
  {
    "sourcePath": "reference/deductions/list-deductions.md",
    "routePath": "reference/deductions/list-deductions",
    "title": "List Deductions"
  },
  {
    "sourcePath": "reference/deductions/list-employee-deductions.md",
    "routePath": "reference/deductions/list-employee-deductions",
    "title": "List Employee Deductions"
  },
  {
    "sourcePath": "reference/deductions/remove-employee-deduction.md",
    "routePath": "reference/deductions/remove-employee-deduction",
    "title": "Remove Employee Deduction Assignment"
  },
  {
    "sourcePath": "reference/deductions/update-deduction.md",
    "routePath": "reference/deductions/update-deduction",
    "title": "Update Deduction"
  },
  {
    "sourcePath": "reference/dependents/create-dependent.md",
    "routePath": "reference/dependents/create-dependent",
    "title": "Create Dependent"
  },
  {
    "sourcePath": "reference/dependents/delete-dependent.md",
    "routePath": "reference/dependents/delete-dependent",
    "title": "Delete Dependent"
  },
  {
    "sourcePath": "reference/dependents/get-dependent-tax-count.md",
    "routePath": "reference/dependents/get-dependent-tax-count",
    "title": "Get Dependent Tax Count"
  },
  {
    "sourcePath": "reference/dependents/get-dependent.md",
    "routePath": "reference/dependents/get-dependent",
    "title": "Get Dependent"
  },
  {
    "sourcePath": "reference/dependents/list-dependents.md",
    "routePath": "reference/dependents/list-dependents",
    "title": "List Dependents For Employee"
  },
  {
    "sourcePath": "reference/dependents/update-dependent.md",
    "routePath": "reference/dependents/update-dependent",
    "title": "Update Dependent"
  },
  {
    "sourcePath": "reference/direct-deposit/create-direct-deposit-account.md",
    "routePath": "reference/direct-deposit/create-direct-deposit-account",
    "title": "Create Direct Deposit Account"
  },
  {
    "sourcePath": "reference/direct-deposit/delete-direct-deposit-account.md",
    "routePath": "reference/direct-deposit/delete-direct-deposit-account",
    "title": "Delete Direct Deposit Account"
  },
  {
    "sourcePath": "reference/direct-deposit/list-direct-deposit-accounts.md",
    "routePath": "reference/direct-deposit/list-direct-deposit-accounts",
    "title": "List Direct Deposit Accounts"
  },
  {
    "sourcePath": "reference/direct-deposit/update-direct-deposit-account.md",
    "routePath": "reference/direct-deposit/update-direct-deposit-account",
    "title": "Update Direct Deposit Account"
  },
  {
    "sourcePath": "reference/emergency-contacts/create-emergency-contact.md",
    "routePath": "reference/emergency-contacts/create-emergency-contact",
    "title": "Create Emergency Contact"
  },
  {
    "sourcePath": "reference/emergency-contacts/delete-emergency-contact.md",
    "routePath": "reference/emergency-contacts/delete-emergency-contact",
    "title": "Delete Emergency Contact"
  },
  {
    "sourcePath": "reference/emergency-contacts/list-emergency-contacts.md",
    "routePath": "reference/emergency-contacts/list-emergency-contacts",
    "title": "List Emergency Contacts"
  },
  {
    "sourcePath": "reference/emergency-contacts/update-emergency-contact.md",
    "routePath": "reference/emergency-contacts/update-emergency-contact",
    "title": "Update Emergency Contact"
  },
  {
    "sourcePath": "reference/employees/create-employee.md",
    "routePath": "reference/employees/create-employee",
    "title": "Create Employee"
  },
  {
    "sourcePath": "reference/employees/delete-employee.md",
    "routePath": "reference/employees/delete-employee",
    "title": "Delete Employee"
  },
  {
    "sourcePath": "reference/employees/get-employee-pay-history.md",
    "routePath": "reference/employees/get-employee-pay-history",
    "title": "Get Employee Pay History"
  },
  {
    "sourcePath": "reference/employees/get-employee-tax-history.md",
    "routePath": "reference/employees/get-employee-tax-history",
    "title": "Get Employee Tax History"
  },
  {
    "sourcePath": "reference/employees/get-employee-ytd-earnings.md",
    "routePath": "reference/employees/get-employee-ytd-earnings",
    "title": "Get Employee YTD Earnings"
  },
  {
    "sourcePath": "reference/employees/get-employee.md",
    "routePath": "reference/employees/get-employee",
    "title": "Get Employee"
  },
  {
    "sourcePath": "reference/employees/list-employees.md",
    "routePath": "reference/employees/list-employees",
    "title": "List Employees"
  },
  {
    "sourcePath": "reference/employees/update-employee.md",
    "routePath": "reference/employees/update-employee",
    "title": "Update Employee"
  },
  {
    "sourcePath": "reference/health/get-health.md",
    "routePath": "reference/health/get-health",
    "title": "Health Check"
  },
  {
    "sourcePath": "reference/holidays/check-holiday.md",
    "routePath": "reference/holidays/check-holiday",
    "title": "Check If Date Is Holiday"
  },
  {
    "sourcePath": "reference/holidays/create-holiday.md",
    "routePath": "reference/holidays/create-holiday",
    "title": "Create Holiday"
  },
  {
    "sourcePath": "reference/holidays/delete-holiday.md",
    "routePath": "reference/holidays/delete-holiday",
    "title": "Delete Holiday"
  },
  {
    "sourcePath": "reference/holidays/get-holiday.md",
    "routePath": "reference/holidays/get-holiday",
    "title": "Get Holiday"
  },
  {
    "sourcePath": "reference/holidays/holidays-in-range.md",
    "routePath": "reference/holidays/holidays-in-range",
    "title": "List Holidays In Date Range"
  },
  {
    "sourcePath": "reference/holidays/list-holidays.md",
    "routePath": "reference/holidays/list-holidays",
    "title": "List Holidays"
  },
  {
    "sourcePath": "reference/holidays/seed-federal-holidays.md",
    "routePath": "reference/holidays/seed-federal-holidays",
    "title": "Seed Federal Holidays"
  },
  {
    "sourcePath": "reference/holidays/update-holiday.md",
    "routePath": "reference/holidays/update-holiday",
    "title": "Update Holiday"
  },
  {
    "sourcePath": "reference/introduction.md",
    "routePath": "reference/introduction",
    "title": "Reference Introduction"
  },
  {
    "sourcePath": "reference/leave/approve-leave-request.md",
    "routePath": "reference/leave/approve-leave-request",
    "title": "Approve Leave Request"
  },
  {
    "sourcePath": "reference/leave/backfill-leave-balances.md",
    "routePath": "reference/leave/backfill-leave-balances",
    "title": "Backfill Leave Balances"
  },
  {
    "sourcePath": "reference/leave/calculate-leave-accrual.md",
    "routePath": "reference/leave/calculate-leave-accrual",
    "title": "Calculate Leave Accrual"
  },
  {
    "sourcePath": "reference/leave/cancel-leave-request.md",
    "routePath": "reference/leave/cancel-leave-request",
    "title": "Cancel Leave Request"
  },
  {
    "sourcePath": "reference/leave/create-leave-balance.md",
    "routePath": "reference/leave/create-leave-balance",
    "title": "Create Leave Balance"
  },
  {
    "sourcePath": "reference/leave/create-leave-request.md",
    "routePath": "reference/leave/create-leave-request",
    "title": "Create Leave Request"
  },
  {
    "sourcePath": "reference/leave/delete-leave-request.md",
    "routePath": "reference/leave/delete-leave-request",
    "title": "Delete Leave Request"
  },
  {
    "sourcePath": "reference/leave/get-employee-leave-balances.md",
    "routePath": "reference/leave/get-employee-leave-balances",
    "title": "Get Employee Leave Balances"
  },
  {
    "sourcePath": "reference/leave/get-leave-request.md",
    "routePath": "reference/leave/get-leave-request",
    "title": "Get Leave Request"
  },
  {
    "sourcePath": "reference/leave/initialize-leave-balances.md",
    "routePath": "reference/leave/initialize-leave-balances",
    "title": "Initialize Leave Balances For Company"
  },
  {
    "sourcePath": "reference/leave/list-company-leave-requests.md",
    "routePath": "reference/leave/list-company-leave-requests",
    "title": "List Leave Requests (Company)"
  },
  {
    "sourcePath": "reference/leave/list-employee-leave-requests.md",
    "routePath": "reference/leave/list-employee-leave-requests",
    "title": "List Leave Requests (Employee)"
  },
  {
    "sourcePath": "reference/leave/reject-leave-request.md",
    "routePath": "reference/leave/reject-leave-request",
    "title": "Reject Leave Request"
  },
  {
    "sourcePath": "reference/leave/update-leave-balance.md",
    "routePath": "reference/leave/update-leave-balance",
    "title": "Update Leave Balance"
  },
  {
    "sourcePath": "reference/leave/update-leave-request.md",
    "routePath": "reference/leave/update-leave-request",
    "title": "Update Leave Request"
  },
  {
    "sourcePath": "reference/notifications/delete-notification.md",
    "routePath": "reference/notifications/delete-notification",
    "title": "Delete Notification"
  },
  {
    "sourcePath": "reference/notifications/delete-read-notifications.md",
    "routePath": "reference/notifications/delete-read-notifications",
    "title": "Delete All Read Notifications"
  },
  {
    "sourcePath": "reference/notifications/list-notifications.md",
    "routePath": "reference/notifications/list-notifications",
    "title": "List Notifications"
  },
  {
    "sourcePath": "reference/notifications/mark-all-read.md",
    "routePath": "reference/notifications/mark-all-read",
    "title": "Mark All Notifications Read"
  },
  {
    "sourcePath": "reference/notifications/mark-notification-read.md",
    "routePath": "reference/notifications/mark-notification-read",
    "title": "Mark Notification Read"
  },
  {
    "sourcePath": "reference/notifications/send-bulk-notification.md",
    "routePath": "reference/notifications/send-bulk-notification",
    "title": "Send Bulk Notification Email"
  },
  {
    "sourcePath": "reference/notifications/send-leave-request-notification.md",
    "routePath": "reference/notifications/send-leave-request-notification",
    "title": "Send Leave Request Notification Email"
  },
  {
    "sourcePath": "reference/notifications/send-payroll-reminder.md",
    "routePath": "reference/notifications/send-payroll-reminder",
    "title": "Send Payroll Reminder Email"
  },
  {
    "sourcePath": "reference/notifications/send-payslip-notification.md",
    "routePath": "reference/notifications/send-payslip-notification",
    "title": "Send Payslip Notification Email"
  },
  {
    "sourcePath": "reference/notifications/send-system-notification.md",
    "routePath": "reference/notifications/send-system-notification",
    "title": "Send System Notification Email"
  },
  {
    "sourcePath": "reference/notifications/send-tax-filing-reminder.md",
    "routePath": "reference/notifications/send-tax-filing-reminder",
    "title": "Send Tax Filing Reminder Email"
  },
  {
    "sourcePath": "reference/notifications/unread-count.md",
    "routePath": "reference/notifications/unread-count",
    "title": "Notification Unread Count"
  },
  {
    "sourcePath": "reference/pay-adjustments/approve-adjustment.md",
    "routePath": "reference/pay-adjustments/approve-adjustment",
    "title": "Approve Pay Adjustment"
  },
  {
    "sourcePath": "reference/pay-adjustments/create-correction-adjustment.md",
    "routePath": "reference/pay-adjustments/create-correction-adjustment",
    "title": "Create Correction Adjustment"
  },
  {
    "sourcePath": "reference/pay-adjustments/create-retroactive-adjustment.md",
    "routePath": "reference/pay-adjustments/create-retroactive-adjustment",
    "title": "Create Retroactive Adjustment"
  },
  {
    "sourcePath": "reference/pay-adjustments/create-reversal-adjustment.md",
    "routePath": "reference/pay-adjustments/create-reversal-adjustment",
    "title": "Create Reversal Adjustment"
  },
  {
    "sourcePath": "reference/pay-adjustments/get-adjustment.md",
    "routePath": "reference/pay-adjustments/get-adjustment",
    "title": "Get Pay Adjustment"
  },
  {
    "sourcePath": "reference/pay-adjustments/list-employee-adjustments.md",
    "routePath": "reference/pay-adjustments/list-employee-adjustments",
    "title": "List Adjustments For Employee"
  },
  {
    "sourcePath": "reference/pay-adjustments/list-payroll-run-adjustments.md",
    "routePath": "reference/pay-adjustments/list-payroll-run-adjustments",
    "title": "List Adjustments For Payroll Run"
  },
  {
    "sourcePath": "reference/pay-adjustments/list-pending-adjustments.md",
    "routePath": "reference/pay-adjustments/list-pending-adjustments",
    "title": "List Pending Adjustments"
  },
  {
    "sourcePath": "reference/pay-adjustments/process-adjustment.md",
    "routePath": "reference/pay-adjustments/process-adjustment",
    "title": "Process Adjustment"
  },
  {
    "sourcePath": "reference/pay-adjustments/reverse-adjustment.md",
    "routePath": "reference/pay-adjustments/reverse-adjustment",
    "title": "Reverse Pay Adjustment"
  },
  {
    "sourcePath": "reference/payment-methods/generate-nacha.md",
    "routePath": "reference/payment-methods/generate-nacha",
    "title": "Generate NACHA"
  },
  {
    "sourcePath": "reference/payment-methods/get-nacha-info.md",
    "routePath": "reference/payment-methods/get-nacha-info",
    "title": "Get NACHA Info"
  },
  {
    "sourcePath": "reference/payment-methods/list-checks-for-run.md",
    "routePath": "reference/payment-methods/list-checks-for-run",
    "title": "List Checks For Payroll Run"
  },
  {
    "sourcePath": "reference/payment-methods/list-finalized-payroll-runs.md",
    "routePath": "reference/payment-methods/list-finalized-payroll-runs",
    "title": "List Finalized Payroll Runs For Payments"
  },
  {
    "sourcePath": "reference/payment-methods/print-all-checks.md",
    "routePath": "reference/payment-methods/print-all-checks",
    "title": "Print All Checks (PDF)"
  },
  {
    "sourcePath": "reference/payment-methods/print-check.md",
    "routePath": "reference/payment-methods/print-check",
    "title": "Print Single Check (PDF)"
  },
  {
    "sourcePath": "reference/payroll-policies/create-payroll-policy.md",
    "routePath": "reference/payroll-policies/create-payroll-policy",
    "title": "Create Payroll Policy"
  },
  {
    "sourcePath": "reference/payroll-policies/delete-payroll-policy.md",
    "routePath": "reference/payroll-policies/delete-payroll-policy",
    "title": "Delete Payroll Policy"
  },
  {
    "sourcePath": "reference/payroll-policies/get-payroll-policy.md",
    "routePath": "reference/payroll-policies/get-payroll-policy",
    "title": "Get Payroll Policy"
  },
  {
    "sourcePath": "reference/payroll-policies/get-policy-template.md",
    "routePath": "reference/payroll-policies/get-policy-template",
    "title": "Get Payroll Policy Template"
  },
  {
    "sourcePath": "reference/payroll-policies/list-all-policy-templates.md",
    "routePath": "reference/payroll-policies/list-all-policy-templates",
    "title": "List All Payroll Policy Templates"
  },
  {
    "sourcePath": "reference/payroll-policies/list-payroll-policies.md",
    "routePath": "reference/payroll-policies/list-payroll-policies",
    "title": "List Payroll Policies"
  },
  {
    "sourcePath": "reference/payroll-policies/update-payroll-policy.md",
    "routePath": "reference/payroll-policies/update-payroll-policy",
    "title": "Update Payroll Policy"
  },
  {
    "sourcePath": "reference/payroll/approve-payroll-run.md",
    "routePath": "reference/payroll/approve-payroll-run",
    "title": "Approve Payroll Run"
  },
  {
    "sourcePath": "reference/payroll/cancel-payroll-run.md",
    "routePath": "reference/payroll/cancel-payroll-run",
    "title": "Cancel Payroll Run"
  },
  {
    "sourcePath": "reference/payroll/create-payroll-run.md",
    "routePath": "reference/payroll/create-payroll-run",
    "title": "Create Payroll Run"
  },
  {
    "sourcePath": "reference/payroll/delete-payroll-run.md",
    "routePath": "reference/payroll/delete-payroll-run",
    "title": "Delete Payroll Run"
  },
  {
    "sourcePath": "reference/payroll/erp-journal-preview.md",
    "routePath": "reference/payroll/erp-journal-preview",
    "title": "ERP Journal Preview"
  },
  {
    "sourcePath": "reference/payroll/erp-journal-sync.md",
    "routePath": "reference/payroll/erp-journal-sync",
    "title": "ERP Journal Sync"
  },
  {
    "sourcePath": "reference/payroll/finalize-payroll-run.md",
    "routePath": "reference/payroll/finalize-payroll-run",
    "title": "Finalize Payroll Run"
  },
  {
    "sourcePath": "reference/payroll/get-accounting-breakdown.md",
    "routePath": "reference/payroll/get-accounting-breakdown",
    "title": "Get Accounting Breakdown"
  },
  {
    "sourcePath": "reference/payroll/get-employee-payroll-breakdown.md",
    "routePath": "reference/payroll/get-employee-payroll-breakdown",
    "title": "Get Employee Payroll Breakdown"
  },
  {
    "sourcePath": "reference/payroll/get-next-pay-period.md",
    "routePath": "reference/payroll/get-next-pay-period",
    "title": "Get Next Pay Period"
  },
  {
    "sourcePath": "reference/payroll/get-payroll-run.md",
    "routePath": "reference/payroll/get-payroll-run",
    "title": "Get Payroll Run"
  },
  {
    "sourcePath": "reference/payroll/list-payroll-runs.md",
    "routePath": "reference/payroll/list-payroll-runs",
    "title": "List Payroll Runs"
  },
  {
    "sourcePath": "reference/payroll/process-payroll-run.md",
    "routePath": "reference/payroll/process-payroll-run",
    "title": "Process Payroll Run"
  },
  {
    "sourcePath": "reference/payroll/recalculate-payroll-run.md",
    "routePath": "reference/payroll/recalculate-payroll-run",
    "title": "Recalculate Payroll Run"
  },
  {
    "sourcePath": "reference/payroll/update-payroll-run.md",
    "routePath": "reference/payroll/update-payroll-run",
    "title": "Update Payroll Run"
  },
  {
    "sourcePath": "reference/payslips/download-payslip.md",
    "routePath": "reference/payslips/download-payslip",
    "title": "Download Payslip"
  },
  {
    "sourcePath": "reference/payslips/get-payslip.md",
    "routePath": "reference/payslips/get-payslip",
    "title": "Get Payslip"
  },
  {
    "sourcePath": "reference/payslips/list-company-payslips.md",
    "routePath": "reference/payslips/list-company-payslips",
    "title": "List Company Payslips"
  },
  {
    "sourcePath": "reference/payslips/list-employee-payslips.md",
    "routePath": "reference/payslips/list-employee-payslips",
    "title": "List Employee Payslips"
  },
  {
    "sourcePath": "reference/payslips/list-payroll-run-payslips.md",
    "routePath": "reference/payslips/list-payroll-run-payslips",
    "title": "List Payroll Run Payslips"
  },
  {
    "sourcePath": "reference/payslips/send-payslip-email.md",
    "routePath": "reference/payslips/send-payslip-email",
    "title": "Send Payslip Email"
  },
  {
    "sourcePath": "reference/README.md",
    "routePath": "reference",
    "title": "API Reference"
  },
  {
    "sourcePath": "reference/reports/deduction-analysis.md",
    "routePath": "reference/reports/deduction-analysis",
    "title": "Deduction Analysis Report"
  },
  {
    "sourcePath": "reference/reports/employee-reports.md",
    "routePath": "reference/reports/employee-reports",
    "title": "Employee Reports"
  },
  {
    "sourcePath": "reference/reports/export.md",
    "routePath": "reference/reports/export",
    "title": "Export Report"
  },
  {
    "sourcePath": "reference/reports/payroll-cost.md",
    "routePath": "reference/reports/payroll-cost",
    "title": "Payroll Cost Report"
  },
  {
    "sourcePath": "reference/reports/payroll-summary.md",
    "routePath": "reference/reports/payroll-summary",
    "title": "Payroll Summary Report"
  },
  {
    "sourcePath": "reference/reports/tax-reports.md",
    "routePath": "reference/reports/tax-reports",
    "title": "Tax Reports"
  },
  {
    "sourcePath": "reference/reports/year-end.md",
    "routePath": "reference/reports/year-end",
    "title": "Year-End Report"
  },
  {
    "sourcePath": "reference/smtp/get-smtp-settings.md",
    "routePath": "reference/smtp/get-smtp-settings",
    "title": "Get SMTP Settings"
  },
  {
    "sourcePath": "reference/smtp/test-smtp.md",
    "routePath": "reference/smtp/test-smtp",
    "title": "Send SMTP Test Email"
  },
  {
    "sourcePath": "reference/smtp/update-smtp-settings.md",
    "routePath": "reference/smtp/update-smtp-settings",
    "title": "Update SMTP Settings"
  },
  {
    "sourcePath": "reference/state-tax/calculate-state-tax.md",
    "routePath": "reference/state-tax/calculate-state-tax",
    "title": "Calculate State Tax (Utility)"
  },
  {
    "sourcePath": "reference/state-tax/reciprocal-check.md",
    "routePath": "reference/state-tax/reciprocal-check",
    "title": "Check Reciprocal State Agreement"
  },
  {
    "sourcePath": "reference/state-tax/state-tax-info.md",
    "routePath": "reference/state-tax/state-tax-info",
    "title": "Get State Tax Info"
  },
  {
    "sourcePath": "reference/state-tax/supported-states.md",
    "routePath": "reference/state-tax/supported-states",
    "title": "List Supported State Tax Codes"
  },
  {
    "sourcePath": "reference/tax-filing/form-1099-all-company.md",
    "routePath": "reference/tax-filing/form-1099-all-company",
    "title": "Generate 1099 (All Employees)"
  },
  {
    "sourcePath": "reference/tax-filing/form-1099-employee.md",
    "routePath": "reference/tax-filing/form-1099-employee",
    "title": "Generate 1099 (Employee)"
  },
  {
    "sourcePath": "reference/tax-filing/form-940.md",
    "routePath": "reference/tax-filing/form-940",
    "title": "Generate Form 940"
  },
  {
    "sourcePath": "reference/tax-filing/form-941.md",
    "routePath": "reference/tax-filing/form-941",
    "title": "Generate Form 941"
  },
  {
    "sourcePath": "reference/tax-filing/w2-all-company.md",
    "routePath": "reference/tax-filing/w2-all-company",
    "title": "Generate W-2 (All Employees)"
  },
  {
    "sourcePath": "reference/tax-filing/w2-employee.md",
    "routePath": "reference/tax-filing/w2-employee",
    "title": "Generate W-2 (Employee)"
  },
  {
    "sourcePath": "reference/tax-filing/w3-company.md",
    "routePath": "reference/tax-filing/w3-company",
    "title": "Generate W-3"
  },
  {
    "sourcePath": "reference/tax-tables/create-tax-table.md",
    "routePath": "reference/tax-tables/create-tax-table",
    "title": "Create Tax Table"
  },
  {
    "sourcePath": "reference/tax-tables/delete-tax-table.md",
    "routePath": "reference/tax-tables/delete-tax-table",
    "title": "Delete Tax Table"
  },
  {
    "sourcePath": "reference/tax-tables/get-tax-table.md",
    "routePath": "reference/tax-tables/get-tax-table",
    "title": "Get Tax Table"
  },
  {
    "sourcePath": "reference/tax-tables/list-tax-tables.md",
    "routePath": "reference/tax-tables/list-tax-tables",
    "title": "List Tax Tables"
  },
  {
    "sourcePath": "reference/tax-tables/update-tax-table.md",
    "routePath": "reference/tax-tables/update-tax-table",
    "title": "Update Tax Table"
  },
  {
    "sourcePath": "reference/time-attendance/approve-time-entry.md",
    "routePath": "reference/time-attendance/approve-time-entry",
    "title": "Approve Time Entry"
  },
  {
    "sourcePath": "reference/time-attendance/clock-in.md",
    "routePath": "reference/time-attendance/clock-in",
    "title": "Clock In"
  },
  {
    "sourcePath": "reference/time-attendance/clock-out.md",
    "routePath": "reference/time-attendance/clock-out",
    "title": "Clock Out"
  },
  {
    "sourcePath": "reference/time-attendance/create-time-entry.md",
    "routePath": "reference/time-attendance/create-time-entry",
    "title": "Create Time Entry"
  },
  {
    "sourcePath": "reference/time-attendance/delete-all-company-time-entries.md",
    "routePath": "reference/time-attendance/delete-all-company-time-entries",
    "title": "Delete All Time Entries For Company"
  },
  {
    "sourcePath": "reference/time-attendance/delete-time-entry.md",
    "routePath": "reference/time-attendance/delete-time-entry",
    "title": "Delete Time Entry"
  },
  {
    "sourcePath": "reference/time-attendance/end-break.md",
    "routePath": "reference/time-attendance/end-break",
    "title": "End Break"
  },
  {
    "sourcePath": "reference/time-attendance/get-current-clock-in.md",
    "routePath": "reference/time-attendance/get-current-clock-in",
    "title": "Get Current Clock-In"
  },
  {
    "sourcePath": "reference/time-attendance/get-time-entry.md",
    "routePath": "reference/time-attendance/get-time-entry",
    "title": "Get Time Entry"
  },
  {
    "sourcePath": "reference/time-attendance/import-time-entries.md",
    "routePath": "reference/time-attendance/import-time-entries",
    "title": "Import Time Entries"
  },
  {
    "sourcePath": "reference/time-attendance/list-company-time-entries.md",
    "routePath": "reference/time-attendance/list-company-time-entries",
    "title": "List Company Time Entries"
  },
  {
    "sourcePath": "reference/time-attendance/list-employee-time-entries.md",
    "routePath": "reference/time-attendance/list-employee-time-entries",
    "title": "List Employee Time Entries"
  },
  {
    "sourcePath": "reference/time-attendance/reject-time-entry.md",
    "routePath": "reference/time-attendance/reject-time-entry",
    "title": "Reject Time Entry"
  },
  {
    "sourcePath": "reference/time-attendance/start-break.md",
    "routePath": "reference/time-attendance/start-break",
    "title": "Start Break"
  },
  {
    "sourcePath": "reference/time-attendance/submit-time-entry.md",
    "routePath": "reference/time-attendance/submit-time-entry",
    "title": "Submit Time Entry"
  },
  {
    "sourcePath": "reference/time-attendance/update-time-entry.md",
    "routePath": "reference/time-attendance/update-time-entry",
    "title": "Update Time Entry"
  }
];

export const cimmplePayDocsByRoute = new Map(
  cimmplePayDocsManifest.map((item) => [item.routePath, item])
);

export type CimmplePayReferenceFolder = {
  folder: string;
  label: string;
  items: CimmplePayDocItem[];
};

/** Reference docs grouped by subfolder (preserves hierarchy in nav). */
export const cimmplePaySidebarReferenceFolders: CimmplePayReferenceFolder[] = [
  {
    "folder": "",
    "label": "Overview",
    "items": [
      {
        "sourcePath": "reference/introduction.md",
        "routePath": "reference/introduction",
        "title": "Reference Introduction"
      },
      {
        "sourcePath": "reference/README.md",
        "routePath": "reference",
        "title": "API Reference"
      }
    ]
  },
  {
    "folder": "audit-logs",
    "label": "Audit Logs",
    "items": [
      {
        "sourcePath": "reference/audit-logs/create-audit-log.md",
        "routePath": "reference/audit-logs/create-audit-log",
        "title": "Create Audit Log"
      },
      {
        "sourcePath": "reference/audit-logs/get-audit-log.md",
        "routePath": "reference/audit-logs/get-audit-log",
        "title": "Get Audit Log"
      },
      {
        "sourcePath": "reference/audit-logs/list-audit-logs.md",
        "routePath": "reference/audit-logs/list-audit-logs",
        "title": "List Audit Logs"
      }
    ]
  },
  {
    "folder": "auth",
    "label": "Auth",
    "items": [
      {
        "sourcePath": "reference/auth/change-password.md",
        "routePath": "reference/auth/change-password",
        "title": "Change Password"
      },
      {
        "sourcePath": "reference/auth/list-user-companies.md",
        "routePath": "reference/auth/list-user-companies",
        "title": "List User Companies (Auth)"
      },
      {
        "sourcePath": "reference/auth/login.md",
        "routePath": "reference/auth/login",
        "title": "Login"
      },
      {
        "sourcePath": "reference/auth/me.md",
        "routePath": "reference/auth/me",
        "title": "Get Current User"
      },
      {
        "sourcePath": "reference/auth/register.md",
        "routePath": "reference/auth/register",
        "title": "Register User"
      },
      {
        "sourcePath": "reference/auth/reset-admin-password.md",
        "routePath": "reference/auth/reset-admin-password",
        "title": "Reset Admin Password (Development)"
      },
      {
        "sourcePath": "reference/auth/switch-company.md",
        "routePath": "reference/auth/switch-company",
        "title": "Switch Company"
      }
    ]
  },
  {
    "folder": "beneficiaries",
    "label": "Beneficiaries",
    "items": [
      {
        "sourcePath": "reference/beneficiaries/create-beneficiary.md",
        "routePath": "reference/beneficiaries/create-beneficiary",
        "title": "Create Beneficiary"
      },
      {
        "sourcePath": "reference/beneficiaries/delete-beneficiary.md",
        "routePath": "reference/beneficiaries/delete-beneficiary",
        "title": "Delete Beneficiary"
      },
      {
        "sourcePath": "reference/beneficiaries/get-beneficiary.md",
        "routePath": "reference/beneficiaries/get-beneficiary",
        "title": "Get Beneficiary"
      },
      {
        "sourcePath": "reference/beneficiaries/list-beneficiaries.md",
        "routePath": "reference/beneficiaries/list-beneficiaries",
        "title": "List Beneficiaries For Employee"
      },
      {
        "sourcePath": "reference/beneficiaries/update-beneficiary.md",
        "routePath": "reference/beneficiaries/update-beneficiary",
        "title": "Update Beneficiary"
      },
      {
        "sourcePath": "reference/beneficiaries/validate-beneficiaries.md",
        "routePath": "reference/beneficiaries/validate-beneficiaries",
        "title": "Validate Beneficiary Allocations"
      }
    ]
  },
  {
    "folder": "benefits",
    "label": "Benefits",
    "items": [
      {
        "sourcePath": "reference/benefits/assign-benefit-to-employee.md",
        "routePath": "reference/benefits/assign-benefit-to-employee",
        "title": "Assign Benefit To Employee"
      },
      {
        "sourcePath": "reference/benefits/create-benefit.md",
        "routePath": "reference/benefits/create-benefit",
        "title": "Create Benefit"
      },
      {
        "sourcePath": "reference/benefits/delete-benefit.md",
        "routePath": "reference/benefits/delete-benefit",
        "title": "Delete Benefit"
      },
      {
        "sourcePath": "reference/benefits/get-benefit.md",
        "routePath": "reference/benefits/get-benefit",
        "title": "Get Benefit"
      },
      {
        "sourcePath": "reference/benefits/list-benefits.md",
        "routePath": "reference/benefits/list-benefits",
        "title": "List Benefits"
      },
      {
        "sourcePath": "reference/benefits/list-employee-benefits.md",
        "routePath": "reference/benefits/list-employee-benefits",
        "title": "List Employee Benefits"
      },
      {
        "sourcePath": "reference/benefits/remove-employee-benefit.md",
        "routePath": "reference/benefits/remove-employee-benefit",
        "title": "Remove Employee Benefit Assignment"
      },
      {
        "sourcePath": "reference/benefits/update-benefit.md",
        "routePath": "reference/benefits/update-benefit",
        "title": "Update Benefit"
      }
    ]
  },
  {
    "folder": "companies",
    "label": "Companies",
    "items": [
      {
        "sourcePath": "reference/companies/create-company.md",
        "routePath": "reference/companies/create-company",
        "title": "Create Company"
      },
      {
        "sourcePath": "reference/companies/delete-company.md",
        "routePath": "reference/companies/delete-company",
        "title": "Delete Company"
      },
      {
        "sourcePath": "reference/companies/get-company.md",
        "routePath": "reference/companies/get-company",
        "title": "Get Company"
      },
      {
        "sourcePath": "reference/companies/list-companies.md",
        "routePath": "reference/companies/list-companies",
        "title": "List Companies"
      },
      {
        "sourcePath": "reference/companies/update-company.md",
        "routePath": "reference/companies/update-company",
        "title": "Update Company"
      }
    ]
  },
  {
    "folder": "deductions",
    "label": "Deductions",
    "items": [
      {
        "sourcePath": "reference/deductions/assign-deduction-to-employee.md",
        "routePath": "reference/deductions/assign-deduction-to-employee",
        "title": "Assign Deduction To Employee"
      },
      {
        "sourcePath": "reference/deductions/create-deduction.md",
        "routePath": "reference/deductions/create-deduction",
        "title": "Create Deduction"
      },
      {
        "sourcePath": "reference/deductions/delete-deduction.md",
        "routePath": "reference/deductions/delete-deduction",
        "title": "Delete Deduction"
      },
      {
        "sourcePath": "reference/deductions/get-deduction.md",
        "routePath": "reference/deductions/get-deduction",
        "title": "Get Deduction"
      },
      {
        "sourcePath": "reference/deductions/list-deductions.md",
        "routePath": "reference/deductions/list-deductions",
        "title": "List Deductions"
      },
      {
        "sourcePath": "reference/deductions/list-employee-deductions.md",
        "routePath": "reference/deductions/list-employee-deductions",
        "title": "List Employee Deductions"
      },
      {
        "sourcePath": "reference/deductions/remove-employee-deduction.md",
        "routePath": "reference/deductions/remove-employee-deduction",
        "title": "Remove Employee Deduction Assignment"
      },
      {
        "sourcePath": "reference/deductions/update-deduction.md",
        "routePath": "reference/deductions/update-deduction",
        "title": "Update Deduction"
      }
    ]
  },
  {
    "folder": "dependents",
    "label": "Dependents",
    "items": [
      {
        "sourcePath": "reference/dependents/create-dependent.md",
        "routePath": "reference/dependents/create-dependent",
        "title": "Create Dependent"
      },
      {
        "sourcePath": "reference/dependents/delete-dependent.md",
        "routePath": "reference/dependents/delete-dependent",
        "title": "Delete Dependent"
      },
      {
        "sourcePath": "reference/dependents/get-dependent-tax-count.md",
        "routePath": "reference/dependents/get-dependent-tax-count",
        "title": "Get Dependent Tax Count"
      },
      {
        "sourcePath": "reference/dependents/get-dependent.md",
        "routePath": "reference/dependents/get-dependent",
        "title": "Get Dependent"
      },
      {
        "sourcePath": "reference/dependents/list-dependents.md",
        "routePath": "reference/dependents/list-dependents",
        "title": "List Dependents For Employee"
      },
      {
        "sourcePath": "reference/dependents/update-dependent.md",
        "routePath": "reference/dependents/update-dependent",
        "title": "Update Dependent"
      }
    ]
  },
  {
    "folder": "direct-deposit",
    "label": "Direct Deposit",
    "items": [
      {
        "sourcePath": "reference/direct-deposit/create-direct-deposit-account.md",
        "routePath": "reference/direct-deposit/create-direct-deposit-account",
        "title": "Create Direct Deposit Account"
      },
      {
        "sourcePath": "reference/direct-deposit/delete-direct-deposit-account.md",
        "routePath": "reference/direct-deposit/delete-direct-deposit-account",
        "title": "Delete Direct Deposit Account"
      },
      {
        "sourcePath": "reference/direct-deposit/list-direct-deposit-accounts.md",
        "routePath": "reference/direct-deposit/list-direct-deposit-accounts",
        "title": "List Direct Deposit Accounts"
      },
      {
        "sourcePath": "reference/direct-deposit/update-direct-deposit-account.md",
        "routePath": "reference/direct-deposit/update-direct-deposit-account",
        "title": "Update Direct Deposit Account"
      }
    ]
  },
  {
    "folder": "emergency-contacts",
    "label": "Emergency Contacts",
    "items": [
      {
        "sourcePath": "reference/emergency-contacts/create-emergency-contact.md",
        "routePath": "reference/emergency-contacts/create-emergency-contact",
        "title": "Create Emergency Contact"
      },
      {
        "sourcePath": "reference/emergency-contacts/delete-emergency-contact.md",
        "routePath": "reference/emergency-contacts/delete-emergency-contact",
        "title": "Delete Emergency Contact"
      },
      {
        "sourcePath": "reference/emergency-contacts/list-emergency-contacts.md",
        "routePath": "reference/emergency-contacts/list-emergency-contacts",
        "title": "List Emergency Contacts"
      },
      {
        "sourcePath": "reference/emergency-contacts/update-emergency-contact.md",
        "routePath": "reference/emergency-contacts/update-emergency-contact",
        "title": "Update Emergency Contact"
      }
    ]
  },
  {
    "folder": "employees",
    "label": "Employees",
    "items": [
      {
        "sourcePath": "reference/employees/create-employee.md",
        "routePath": "reference/employees/create-employee",
        "title": "Create Employee"
      },
      {
        "sourcePath": "reference/employees/delete-employee.md",
        "routePath": "reference/employees/delete-employee",
        "title": "Delete Employee"
      },
      {
        "sourcePath": "reference/employees/get-employee-pay-history.md",
        "routePath": "reference/employees/get-employee-pay-history",
        "title": "Get Employee Pay History"
      },
      {
        "sourcePath": "reference/employees/get-employee-tax-history.md",
        "routePath": "reference/employees/get-employee-tax-history",
        "title": "Get Employee Tax History"
      },
      {
        "sourcePath": "reference/employees/get-employee-ytd-earnings.md",
        "routePath": "reference/employees/get-employee-ytd-earnings",
        "title": "Get Employee YTD Earnings"
      },
      {
        "sourcePath": "reference/employees/get-employee.md",
        "routePath": "reference/employees/get-employee",
        "title": "Get Employee"
      },
      {
        "sourcePath": "reference/employees/list-employees.md",
        "routePath": "reference/employees/list-employees",
        "title": "List Employees"
      },
      {
        "sourcePath": "reference/employees/update-employee.md",
        "routePath": "reference/employees/update-employee",
        "title": "Update Employee"
      }
    ]
  },
  {
    "folder": "health",
    "label": "Health",
    "items": [
      {
        "sourcePath": "reference/health/get-health.md",
        "routePath": "reference/health/get-health",
        "title": "Health Check"
      }
    ]
  },
  {
    "folder": "holidays",
    "label": "Holidays",
    "items": [
      {
        "sourcePath": "reference/holidays/check-holiday.md",
        "routePath": "reference/holidays/check-holiday",
        "title": "Check If Date Is Holiday"
      },
      {
        "sourcePath": "reference/holidays/create-holiday.md",
        "routePath": "reference/holidays/create-holiday",
        "title": "Create Holiday"
      },
      {
        "sourcePath": "reference/holidays/delete-holiday.md",
        "routePath": "reference/holidays/delete-holiday",
        "title": "Delete Holiday"
      },
      {
        "sourcePath": "reference/holidays/get-holiday.md",
        "routePath": "reference/holidays/get-holiday",
        "title": "Get Holiday"
      },
      {
        "sourcePath": "reference/holidays/holidays-in-range.md",
        "routePath": "reference/holidays/holidays-in-range",
        "title": "List Holidays In Date Range"
      },
      {
        "sourcePath": "reference/holidays/list-holidays.md",
        "routePath": "reference/holidays/list-holidays",
        "title": "List Holidays"
      },
      {
        "sourcePath": "reference/holidays/seed-federal-holidays.md",
        "routePath": "reference/holidays/seed-federal-holidays",
        "title": "Seed Federal Holidays"
      },
      {
        "sourcePath": "reference/holidays/update-holiday.md",
        "routePath": "reference/holidays/update-holiday",
        "title": "Update Holiday"
      }
    ]
  },
  {
    "folder": "leave",
    "label": "Leave",
    "items": [
      {
        "sourcePath": "reference/leave/approve-leave-request.md",
        "routePath": "reference/leave/approve-leave-request",
        "title": "Approve Leave Request"
      },
      {
        "sourcePath": "reference/leave/backfill-leave-balances.md",
        "routePath": "reference/leave/backfill-leave-balances",
        "title": "Backfill Leave Balances"
      },
      {
        "sourcePath": "reference/leave/calculate-leave-accrual.md",
        "routePath": "reference/leave/calculate-leave-accrual",
        "title": "Calculate Leave Accrual"
      },
      {
        "sourcePath": "reference/leave/cancel-leave-request.md",
        "routePath": "reference/leave/cancel-leave-request",
        "title": "Cancel Leave Request"
      },
      {
        "sourcePath": "reference/leave/create-leave-balance.md",
        "routePath": "reference/leave/create-leave-balance",
        "title": "Create Leave Balance"
      },
      {
        "sourcePath": "reference/leave/create-leave-request.md",
        "routePath": "reference/leave/create-leave-request",
        "title": "Create Leave Request"
      },
      {
        "sourcePath": "reference/leave/delete-leave-request.md",
        "routePath": "reference/leave/delete-leave-request",
        "title": "Delete Leave Request"
      },
      {
        "sourcePath": "reference/leave/get-employee-leave-balances.md",
        "routePath": "reference/leave/get-employee-leave-balances",
        "title": "Get Employee Leave Balances"
      },
      {
        "sourcePath": "reference/leave/get-leave-request.md",
        "routePath": "reference/leave/get-leave-request",
        "title": "Get Leave Request"
      },
      {
        "sourcePath": "reference/leave/initialize-leave-balances.md",
        "routePath": "reference/leave/initialize-leave-balances",
        "title": "Initialize Leave Balances For Company"
      },
      {
        "sourcePath": "reference/leave/list-company-leave-requests.md",
        "routePath": "reference/leave/list-company-leave-requests",
        "title": "List Leave Requests (Company)"
      },
      {
        "sourcePath": "reference/leave/list-employee-leave-requests.md",
        "routePath": "reference/leave/list-employee-leave-requests",
        "title": "List Leave Requests (Employee)"
      },
      {
        "sourcePath": "reference/leave/reject-leave-request.md",
        "routePath": "reference/leave/reject-leave-request",
        "title": "Reject Leave Request"
      },
      {
        "sourcePath": "reference/leave/update-leave-balance.md",
        "routePath": "reference/leave/update-leave-balance",
        "title": "Update Leave Balance"
      },
      {
        "sourcePath": "reference/leave/update-leave-request.md",
        "routePath": "reference/leave/update-leave-request",
        "title": "Update Leave Request"
      }
    ]
  },
  {
    "folder": "notifications",
    "label": "Notifications",
    "items": [
      {
        "sourcePath": "reference/notifications/delete-notification.md",
        "routePath": "reference/notifications/delete-notification",
        "title": "Delete Notification"
      },
      {
        "sourcePath": "reference/notifications/delete-read-notifications.md",
        "routePath": "reference/notifications/delete-read-notifications",
        "title": "Delete All Read Notifications"
      },
      {
        "sourcePath": "reference/notifications/list-notifications.md",
        "routePath": "reference/notifications/list-notifications",
        "title": "List Notifications"
      },
      {
        "sourcePath": "reference/notifications/mark-all-read.md",
        "routePath": "reference/notifications/mark-all-read",
        "title": "Mark All Notifications Read"
      },
      {
        "sourcePath": "reference/notifications/mark-notification-read.md",
        "routePath": "reference/notifications/mark-notification-read",
        "title": "Mark Notification Read"
      },
      {
        "sourcePath": "reference/notifications/send-bulk-notification.md",
        "routePath": "reference/notifications/send-bulk-notification",
        "title": "Send Bulk Notification Email"
      },
      {
        "sourcePath": "reference/notifications/send-leave-request-notification.md",
        "routePath": "reference/notifications/send-leave-request-notification",
        "title": "Send Leave Request Notification Email"
      },
      {
        "sourcePath": "reference/notifications/send-payroll-reminder.md",
        "routePath": "reference/notifications/send-payroll-reminder",
        "title": "Send Payroll Reminder Email"
      },
      {
        "sourcePath": "reference/notifications/send-payslip-notification.md",
        "routePath": "reference/notifications/send-payslip-notification",
        "title": "Send Payslip Notification Email"
      },
      {
        "sourcePath": "reference/notifications/send-system-notification.md",
        "routePath": "reference/notifications/send-system-notification",
        "title": "Send System Notification Email"
      },
      {
        "sourcePath": "reference/notifications/send-tax-filing-reminder.md",
        "routePath": "reference/notifications/send-tax-filing-reminder",
        "title": "Send Tax Filing Reminder Email"
      },
      {
        "sourcePath": "reference/notifications/unread-count.md",
        "routePath": "reference/notifications/unread-count",
        "title": "Notification Unread Count"
      }
    ]
  },
  {
    "folder": "pay-adjustments",
    "label": "Pay Adjustments",
    "items": [
      {
        "sourcePath": "reference/pay-adjustments/approve-adjustment.md",
        "routePath": "reference/pay-adjustments/approve-adjustment",
        "title": "Approve Pay Adjustment"
      },
      {
        "sourcePath": "reference/pay-adjustments/create-correction-adjustment.md",
        "routePath": "reference/pay-adjustments/create-correction-adjustment",
        "title": "Create Correction Adjustment"
      },
      {
        "sourcePath": "reference/pay-adjustments/create-retroactive-adjustment.md",
        "routePath": "reference/pay-adjustments/create-retroactive-adjustment",
        "title": "Create Retroactive Adjustment"
      },
      {
        "sourcePath": "reference/pay-adjustments/create-reversal-adjustment.md",
        "routePath": "reference/pay-adjustments/create-reversal-adjustment",
        "title": "Create Reversal Adjustment"
      },
      {
        "sourcePath": "reference/pay-adjustments/get-adjustment.md",
        "routePath": "reference/pay-adjustments/get-adjustment",
        "title": "Get Pay Adjustment"
      },
      {
        "sourcePath": "reference/pay-adjustments/list-employee-adjustments.md",
        "routePath": "reference/pay-adjustments/list-employee-adjustments",
        "title": "List Adjustments For Employee"
      },
      {
        "sourcePath": "reference/pay-adjustments/list-payroll-run-adjustments.md",
        "routePath": "reference/pay-adjustments/list-payroll-run-adjustments",
        "title": "List Adjustments For Payroll Run"
      },
      {
        "sourcePath": "reference/pay-adjustments/list-pending-adjustments.md",
        "routePath": "reference/pay-adjustments/list-pending-adjustments",
        "title": "List Pending Adjustments"
      },
      {
        "sourcePath": "reference/pay-adjustments/process-adjustment.md",
        "routePath": "reference/pay-adjustments/process-adjustment",
        "title": "Process Adjustment"
      },
      {
        "sourcePath": "reference/pay-adjustments/reverse-adjustment.md",
        "routePath": "reference/pay-adjustments/reverse-adjustment",
        "title": "Reverse Pay Adjustment"
      }
    ]
  },
  {
    "folder": "payment-methods",
    "label": "Payment Methods",
    "items": [
      {
        "sourcePath": "reference/payment-methods/generate-nacha.md",
        "routePath": "reference/payment-methods/generate-nacha",
        "title": "Generate NACHA"
      },
      {
        "sourcePath": "reference/payment-methods/get-nacha-info.md",
        "routePath": "reference/payment-methods/get-nacha-info",
        "title": "Get NACHA Info"
      },
      {
        "sourcePath": "reference/payment-methods/list-checks-for-run.md",
        "routePath": "reference/payment-methods/list-checks-for-run",
        "title": "List Checks For Payroll Run"
      },
      {
        "sourcePath": "reference/payment-methods/list-finalized-payroll-runs.md",
        "routePath": "reference/payment-methods/list-finalized-payroll-runs",
        "title": "List Finalized Payroll Runs For Payments"
      },
      {
        "sourcePath": "reference/payment-methods/print-all-checks.md",
        "routePath": "reference/payment-methods/print-all-checks",
        "title": "Print All Checks (PDF)"
      },
      {
        "sourcePath": "reference/payment-methods/print-check.md",
        "routePath": "reference/payment-methods/print-check",
        "title": "Print Single Check (PDF)"
      }
    ]
  },
  {
    "folder": "payroll",
    "label": "Payroll",
    "items": [
      {
        "sourcePath": "reference/payroll/approve-payroll-run.md",
        "routePath": "reference/payroll/approve-payroll-run",
        "title": "Approve Payroll Run"
      },
      {
        "sourcePath": "reference/payroll/cancel-payroll-run.md",
        "routePath": "reference/payroll/cancel-payroll-run",
        "title": "Cancel Payroll Run"
      },
      {
        "sourcePath": "reference/payroll/create-payroll-run.md",
        "routePath": "reference/payroll/create-payroll-run",
        "title": "Create Payroll Run"
      },
      {
        "sourcePath": "reference/payroll/delete-payroll-run.md",
        "routePath": "reference/payroll/delete-payroll-run",
        "title": "Delete Payroll Run"
      },
      {
        "sourcePath": "reference/payroll/erp-journal-preview.md",
        "routePath": "reference/payroll/erp-journal-preview",
        "title": "ERP Journal Preview"
      },
      {
        "sourcePath": "reference/payroll/erp-journal-sync.md",
        "routePath": "reference/payroll/erp-journal-sync",
        "title": "ERP Journal Sync"
      },
      {
        "sourcePath": "reference/payroll/finalize-payroll-run.md",
        "routePath": "reference/payroll/finalize-payroll-run",
        "title": "Finalize Payroll Run"
      },
      {
        "sourcePath": "reference/payroll/get-accounting-breakdown.md",
        "routePath": "reference/payroll/get-accounting-breakdown",
        "title": "Get Accounting Breakdown"
      },
      {
        "sourcePath": "reference/payroll/get-employee-payroll-breakdown.md",
        "routePath": "reference/payroll/get-employee-payroll-breakdown",
        "title": "Get Employee Payroll Breakdown"
      },
      {
        "sourcePath": "reference/payroll/get-next-pay-period.md",
        "routePath": "reference/payroll/get-next-pay-period",
        "title": "Get Next Pay Period"
      },
      {
        "sourcePath": "reference/payroll/get-payroll-run.md",
        "routePath": "reference/payroll/get-payroll-run",
        "title": "Get Payroll Run"
      },
      {
        "sourcePath": "reference/payroll/list-payroll-runs.md",
        "routePath": "reference/payroll/list-payroll-runs",
        "title": "List Payroll Runs"
      },
      {
        "sourcePath": "reference/payroll/process-payroll-run.md",
        "routePath": "reference/payroll/process-payroll-run",
        "title": "Process Payroll Run"
      },
      {
        "sourcePath": "reference/payroll/recalculate-payroll-run.md",
        "routePath": "reference/payroll/recalculate-payroll-run",
        "title": "Recalculate Payroll Run"
      },
      {
        "sourcePath": "reference/payroll/update-payroll-run.md",
        "routePath": "reference/payroll/update-payroll-run",
        "title": "Update Payroll Run"
      }
    ]
  },
  {
    "folder": "payroll-policies",
    "label": "Payroll Policies",
    "items": [
      {
        "sourcePath": "reference/payroll-policies/create-payroll-policy.md",
        "routePath": "reference/payroll-policies/create-payroll-policy",
        "title": "Create Payroll Policy"
      },
      {
        "sourcePath": "reference/payroll-policies/delete-payroll-policy.md",
        "routePath": "reference/payroll-policies/delete-payroll-policy",
        "title": "Delete Payroll Policy"
      },
      {
        "sourcePath": "reference/payroll-policies/get-payroll-policy.md",
        "routePath": "reference/payroll-policies/get-payroll-policy",
        "title": "Get Payroll Policy"
      },
      {
        "sourcePath": "reference/payroll-policies/get-policy-template.md",
        "routePath": "reference/payroll-policies/get-policy-template",
        "title": "Get Payroll Policy Template"
      },
      {
        "sourcePath": "reference/payroll-policies/list-all-policy-templates.md",
        "routePath": "reference/payroll-policies/list-all-policy-templates",
        "title": "List All Payroll Policy Templates"
      },
      {
        "sourcePath": "reference/payroll-policies/list-payroll-policies.md",
        "routePath": "reference/payroll-policies/list-payroll-policies",
        "title": "List Payroll Policies"
      },
      {
        "sourcePath": "reference/payroll-policies/update-payroll-policy.md",
        "routePath": "reference/payroll-policies/update-payroll-policy",
        "title": "Update Payroll Policy"
      }
    ]
  },
  {
    "folder": "payslips",
    "label": "Payslips",
    "items": [
      {
        "sourcePath": "reference/payslips/download-payslip.md",
        "routePath": "reference/payslips/download-payslip",
        "title": "Download Payslip"
      },
      {
        "sourcePath": "reference/payslips/get-payslip.md",
        "routePath": "reference/payslips/get-payslip",
        "title": "Get Payslip"
      },
      {
        "sourcePath": "reference/payslips/list-company-payslips.md",
        "routePath": "reference/payslips/list-company-payslips",
        "title": "List Company Payslips"
      },
      {
        "sourcePath": "reference/payslips/list-employee-payslips.md",
        "routePath": "reference/payslips/list-employee-payslips",
        "title": "List Employee Payslips"
      },
      {
        "sourcePath": "reference/payslips/list-payroll-run-payslips.md",
        "routePath": "reference/payslips/list-payroll-run-payslips",
        "title": "List Payroll Run Payslips"
      },
      {
        "sourcePath": "reference/payslips/send-payslip-email.md",
        "routePath": "reference/payslips/send-payslip-email",
        "title": "Send Payslip Email"
      }
    ]
  },
  {
    "folder": "reports",
    "label": "Reports",
    "items": [
      {
        "sourcePath": "reference/reports/deduction-analysis.md",
        "routePath": "reference/reports/deduction-analysis",
        "title": "Deduction Analysis Report"
      },
      {
        "sourcePath": "reference/reports/employee-reports.md",
        "routePath": "reference/reports/employee-reports",
        "title": "Employee Reports"
      },
      {
        "sourcePath": "reference/reports/export.md",
        "routePath": "reference/reports/export",
        "title": "Export Report"
      },
      {
        "sourcePath": "reference/reports/payroll-cost.md",
        "routePath": "reference/reports/payroll-cost",
        "title": "Payroll Cost Report"
      },
      {
        "sourcePath": "reference/reports/payroll-summary.md",
        "routePath": "reference/reports/payroll-summary",
        "title": "Payroll Summary Report"
      },
      {
        "sourcePath": "reference/reports/tax-reports.md",
        "routePath": "reference/reports/tax-reports",
        "title": "Tax Reports"
      },
      {
        "sourcePath": "reference/reports/year-end.md",
        "routePath": "reference/reports/year-end",
        "title": "Year-End Report"
      }
    ]
  },
  {
    "folder": "smtp",
    "label": "Smtp",
    "items": [
      {
        "sourcePath": "reference/smtp/get-smtp-settings.md",
        "routePath": "reference/smtp/get-smtp-settings",
        "title": "Get SMTP Settings"
      },
      {
        "sourcePath": "reference/smtp/test-smtp.md",
        "routePath": "reference/smtp/test-smtp",
        "title": "Send SMTP Test Email"
      },
      {
        "sourcePath": "reference/smtp/update-smtp-settings.md",
        "routePath": "reference/smtp/update-smtp-settings",
        "title": "Update SMTP Settings"
      }
    ]
  },
  {
    "folder": "state-tax",
    "label": "State Tax",
    "items": [
      {
        "sourcePath": "reference/state-tax/calculate-state-tax.md",
        "routePath": "reference/state-tax/calculate-state-tax",
        "title": "Calculate State Tax (Utility)"
      },
      {
        "sourcePath": "reference/state-tax/reciprocal-check.md",
        "routePath": "reference/state-tax/reciprocal-check",
        "title": "Check Reciprocal State Agreement"
      },
      {
        "sourcePath": "reference/state-tax/state-tax-info.md",
        "routePath": "reference/state-tax/state-tax-info",
        "title": "Get State Tax Info"
      },
      {
        "sourcePath": "reference/state-tax/supported-states.md",
        "routePath": "reference/state-tax/supported-states",
        "title": "List Supported State Tax Codes"
      }
    ]
  },
  {
    "folder": "tax-filing",
    "label": "Tax Filing",
    "items": [
      {
        "sourcePath": "reference/tax-filing/form-1099-all-company.md",
        "routePath": "reference/tax-filing/form-1099-all-company",
        "title": "Generate 1099 (All Employees)"
      },
      {
        "sourcePath": "reference/tax-filing/form-1099-employee.md",
        "routePath": "reference/tax-filing/form-1099-employee",
        "title": "Generate 1099 (Employee)"
      },
      {
        "sourcePath": "reference/tax-filing/form-940.md",
        "routePath": "reference/tax-filing/form-940",
        "title": "Generate Form 940"
      },
      {
        "sourcePath": "reference/tax-filing/form-941.md",
        "routePath": "reference/tax-filing/form-941",
        "title": "Generate Form 941"
      },
      {
        "sourcePath": "reference/tax-filing/w2-all-company.md",
        "routePath": "reference/tax-filing/w2-all-company",
        "title": "Generate W-2 (All Employees)"
      },
      {
        "sourcePath": "reference/tax-filing/w2-employee.md",
        "routePath": "reference/tax-filing/w2-employee",
        "title": "Generate W-2 (Employee)"
      },
      {
        "sourcePath": "reference/tax-filing/w3-company.md",
        "routePath": "reference/tax-filing/w3-company",
        "title": "Generate W-3"
      }
    ]
  },
  {
    "folder": "tax-tables",
    "label": "Tax Tables",
    "items": [
      {
        "sourcePath": "reference/tax-tables/create-tax-table.md",
        "routePath": "reference/tax-tables/create-tax-table",
        "title": "Create Tax Table"
      },
      {
        "sourcePath": "reference/tax-tables/delete-tax-table.md",
        "routePath": "reference/tax-tables/delete-tax-table",
        "title": "Delete Tax Table"
      },
      {
        "sourcePath": "reference/tax-tables/get-tax-table.md",
        "routePath": "reference/tax-tables/get-tax-table",
        "title": "Get Tax Table"
      },
      {
        "sourcePath": "reference/tax-tables/list-tax-tables.md",
        "routePath": "reference/tax-tables/list-tax-tables",
        "title": "List Tax Tables"
      },
      {
        "sourcePath": "reference/tax-tables/update-tax-table.md",
        "routePath": "reference/tax-tables/update-tax-table",
        "title": "Update Tax Table"
      }
    ]
  },
  {
    "folder": "time-attendance",
    "label": "Time Attendance",
    "items": [
      {
        "sourcePath": "reference/time-attendance/approve-time-entry.md",
        "routePath": "reference/time-attendance/approve-time-entry",
        "title": "Approve Time Entry"
      },
      {
        "sourcePath": "reference/time-attendance/clock-in.md",
        "routePath": "reference/time-attendance/clock-in",
        "title": "Clock In"
      },
      {
        "sourcePath": "reference/time-attendance/clock-out.md",
        "routePath": "reference/time-attendance/clock-out",
        "title": "Clock Out"
      },
      {
        "sourcePath": "reference/time-attendance/create-time-entry.md",
        "routePath": "reference/time-attendance/create-time-entry",
        "title": "Create Time Entry"
      },
      {
        "sourcePath": "reference/time-attendance/delete-all-company-time-entries.md",
        "routePath": "reference/time-attendance/delete-all-company-time-entries",
        "title": "Delete All Time Entries For Company"
      },
      {
        "sourcePath": "reference/time-attendance/delete-time-entry.md",
        "routePath": "reference/time-attendance/delete-time-entry",
        "title": "Delete Time Entry"
      },
      {
        "sourcePath": "reference/time-attendance/end-break.md",
        "routePath": "reference/time-attendance/end-break",
        "title": "End Break"
      },
      {
        "sourcePath": "reference/time-attendance/get-current-clock-in.md",
        "routePath": "reference/time-attendance/get-current-clock-in",
        "title": "Get Current Clock-In"
      },
      {
        "sourcePath": "reference/time-attendance/get-time-entry.md",
        "routePath": "reference/time-attendance/get-time-entry",
        "title": "Get Time Entry"
      },
      {
        "sourcePath": "reference/time-attendance/import-time-entries.md",
        "routePath": "reference/time-attendance/import-time-entries",
        "title": "Import Time Entries"
      },
      {
        "sourcePath": "reference/time-attendance/list-company-time-entries.md",
        "routePath": "reference/time-attendance/list-company-time-entries",
        "title": "List Company Time Entries"
      },
      {
        "sourcePath": "reference/time-attendance/list-employee-time-entries.md",
        "routePath": "reference/time-attendance/list-employee-time-entries",
        "title": "List Employee Time Entries"
      },
      {
        "sourcePath": "reference/time-attendance/reject-time-entry.md",
        "routePath": "reference/time-attendance/reject-time-entry",
        "title": "Reject Time Entry"
      },
      {
        "sourcePath": "reference/time-attendance/start-break.md",
        "routePath": "reference/time-attendance/start-break",
        "title": "Start Break"
      },
      {
        "sourcePath": "reference/time-attendance/submit-time-entry.md",
        "routePath": "reference/time-attendance/submit-time-entry",
        "title": "Submit Time Entry"
      },
      {
        "sourcePath": "reference/time-attendance/update-time-entry.md",
        "routePath": "reference/time-attendance/update-time-entry",
        "title": "Update Time Entry"
      }
    ]
  }
];

export const cimmplePaySidebarGroups: Array<{ label: string; items: CimmplePayDocItem[] }> = [
  { label: "Guides", items: [
  {
    "sourcePath": "README.md",
    "routePath": "",
    "title": "CimmplePay Integration Docs"
  },
  {
    "sourcePath": "api-quick-reference.md",
    "routePath": "api-quick-reference",
    "title": "API Quick Reference"
  },
  {
    "sourcePath": "authentication.md",
    "routePath": "authentication",
    "title": "Authentication"
  },
  {
    "sourcePath": "core-flows.md",
    "routePath": "core-flows",
    "title": "Core Integration Flows"
  },
  {
    "sourcePath": "getting-started.md",
    "routePath": "getting-started",
    "title": "Getting Started"
  },
  {
    "sourcePath": "go-live-checklist.md",
    "routePath": "go-live-checklist",
    "title": "Go-Live Checklist"
  }
] },
];
